import { FhsAxios } from "../../services/axios";

export default {
  state: {
    pifs: []
  },
  actions: {
    fetchPifs({ commit, getters }) {
      commit("setPifs", []);
      let url = "user/pifs";
      if (
        getters.isUserVIP &&
        getters.selectedPortfolio !== "all" &&
        getters.selectedPortfolio !== undefined
      ) {
        url += "/" + getters.selectedPortfolio;
      }
      FhsAxios.post(url, {}).then(response => {
        commit("setPifs", response.data.result.pifs);
      });
    }
  },
  mutations: {
    setPifs(state, pifs) {
      state.pifs = pifs;
    }
  },
  getters: {
    pifs(state) {
      return state.pifs;
    }
  }
};
